import React from 'react/lib/ReactWithAddons';
import 'whatwg-fetch';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router'
import { Map, List } from 'immutable';
import moment from 'moment';
import { timestamp } from '../data/ajax';
import { serverCache, notifications, browser, Error } from '../data/server';
import { keys, humanSize } from '../data/misc';
import { ReplaceAnimate } from './animate.jsx';
import { ImplodedList } from './common.jsx';
import { Wait, Err } from './waiting.jsx';
import { FileRecordHeader, FileRecordRow, PersistentIdentifier, copyToClipboard } from './editfiles.jsx';
import { Versions } from './versions.jsx';
import { getSchemaOrderedMajorAndMinorFields } from './schema.jsx';
import PiwikTracker from 'piwik-react-router';

const PT = React.PropTypes;


export const RecordRoute = React.createClass({
    getRecordOrDraft() {
        const { id } = this.props.params;
        let record = serverCache.getRecord(id);
        if (record instanceof Error && record.code == 404) {
            record = serverCache.getDraft(id);
        }
        return record;
    },

    render() {
        const record = this.getRecordOrDraft();
        if (!record) {
            return <Wait/>;
        }
        if (record instanceof Error) {
            return <Err err={record}/>;
        }
        const [rootSchema, blockSchemas] = serverCache.getRecordSchemas(record);
        const community = serverCache.getCommunity(record.getIn(['metadata', 'community']));

        return (
            <ReplaceAnimate>
                <Record record={record} community={community} rootSchema={rootSchema} blockSchemas={blockSchemas} />
            </ReplaceAnimate>
        );
    }
});


const Record = React.createClass({
    mixins: [React.addons.PureRenderMixin],

    getInitialState() {
        var state = { }

        return state;
    },

    catchMatomoEvent(event) {
        event.stopPropagation();
        event.preventDefault();
        if (window._paq) {
            const metadata = this.props.record.get('metadata') || Map();
            const doi = metadata.get('DOI').replace("http://doi.org/", "");
            window._paq.push(['trackEvent', 'b2share', event.type, doi]);
        }
    },

    componentDidMount() {
        this.catchMatomoEvent(new Event("recordview"));
    },

    componentWillUnmount() { },

    renderOrcidLink(field) {
        return field.has('name_identifiers') &&
            field
                .get('name_identifiers', [])
                .filter((v, k) => v.get('scheme').toLowerCase() === 'orcid' && v.get('name_identifier') > '' )
                .map((v, k) => <a href={v.get('scheme_uri') + '/' + v.get('name_identifier') } key={v.get('name_identifier')} target="_blank"><img className="orcid" src="/img/orcid.png"/></a> );
    },

    // ensures root schema v0 and v1 compatibility
    renderLink(field, key, className="") {
        if (field.size && field.has(key)) {
            var v = field.get(key);
            return <span>
                    <Link to={{pathname:'/records', query:{q:v}}} className={className} key={v}>{v}</Link>
                    {this.renderOrcidLink(field)}
                </span>
        } else {
            return <Link to={{pathname:'/records', query:{q:field}}} className={className} key={field}>{field}</Link>
        }
    },

    renderFixedFields(record, community) {
        var self = this;
        function renderTitle(title, i) {
            return i === 0 ?
                <h2 key={i} className="name">{title}</h2> :
                <h3 key={i} className="name">{title}</h3>
        }
        function renderCreators(creators) {
            return (
                <p><span style={{color:'black'}}> by </span>
                <ImplodedList data={creators.map((x) => self.renderLink(x, 'creator_name', 'creator'))} />;</p>
            )
        }
        function renderDates(record) {
            const created = moment(record.get('created')).format('ll');
            const updated = moment(record.get('updated')).format('ll');
            return (
                <div className="dates">
                    <p>
                        <span>Created at </span>{created}</p>
                    <p>
                        <span>Last updated at </span>{updated}
                    </p>
                </div>
            );
        }
        function renderDescription(description) {
            return (
                <p className="description" key={description}>
                    <ImplodedList data={description.split('\n')} delim='<br/>'/>
                </p>
            );
        }
        function renderSmallCommunity(community) {
            return !community ? false :
                (community instanceof Error) ? <Err err={community}/> :
                (
                    <div key={community.get('id')}>
                        <Link to={"/communities/"+community.get('name')}>
                            <div className="community-small passive" title={community.get('description')}>
                                <p className="name">{community.get('name')}</p>
                                <img className="logo" src={community.get('logo')}/>
                            </div>
                        </Link>
                    </div>
                );
        }

        function testget(map, key) {
            const x = map.get(key);
            return (x && x.count && x.count()) ? x : null;
        }

        const metadata = record.get('metadata') || Map();

        const name = metadata.get('Name') || "";
        const description = metadata.get('Description') || "";
        const disciplines = testget(metadata, 'disciplines') || "";
        const keywords = testget(metadata, 'keywords');
        const creators = testget(metadata, 'mowners');
        const pid = metadata.get('ePIC_PID');
        const doi = metadata.get('DOI');
        const state = metadata.get('publication_state');
        return (
            <div>
                <Versions isDraft={state == 'draft'} recordID={record.get('id')} versions={record.get('versions')} />

                <div className="row">
                    <div className="col-sm-12">
                        { renderTitle(name) }
                        { state != 'draft' ? false :
                        <h4 style={{color: '#CCC'}}>(draft preview)</h4>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-8 col-md-10">
                        { creators && renderCreators(creators) }

                        { renderDates(record) }

                        { renderDescription(description) }

                        { disciplines &&
                            <p className="discipline">
                                <span style={{fontWeight:'bold'}}>Disciplines: </span>
                                <ImplodedList data={disciplines.map((x) => self.renderLink(x, 'discipline_name'))} />
                            </p>
                        }

                        { keywords &&
                            <p className="keywords">
                                <span style={{fontWeight:'bold'}}>Keywords: </span>
                                <ImplodedList data={keywords.map((x) => self.renderLink(x, 'keyword'))} />;
                            </p>
                        }

                        { doi &&
                            <p className="pid">
                                <span>DOI: </span>
                                <PersistentIdentifier pid={doi} doi={true}/>
                            </p>
                        }
                        { pid &&
                            <p className="pid">
                                <span>PID: </span>
                                <PersistentIdentifier pid={pid} />
                            </p>
                        }
                    </div>

                    <div className="col-sm-4 col-md-2">
                        { renderSmallCommunity(community) }
                    </div>
                </div>
            </div>
        );
    },

    fixedFields: [
        'community', 'Name', 'description', 'mowners', 'keywords', 'disciplines', 'publication_state'
    ],

    renderFileList(files, showDownloads) {
        const openAccess = this.props.record.getIn(['metadata', 'open_access']);
        const showAccessRequest = (!openAccess && !isRecordOwner(this.props.record));

        let fileComponent = false;
        if (!(files && files.count && files.count())) {
            fileComponent = <div>No files available.</div>;
        } else {
            const fileRecordRowFn = f => {
                return <FileRecordRow key={f.get('key')} file={f} showDownloads={showDownloads} catchMatomoEvent={this.catchMatomoEvent} />
            }
            fileComponent =
                <div className='filelist'>
                    <FileRecordHeader/>
                    <div className='files'>
                    { files.map(fileRecordRowFn) }
                    </div>
                </div>;
        }
        return (
            <div className="well">
                <div className="row">
                    <h3 className="col-sm-9">
                        { 'Resources' }
                    </h3>
                </div>
                { fileComponent }
                { showAccessRequest ?
                    <Link to={`/records/${this.props.record.get('id')}/accessrequest`}>
                        Request data access
                    </Link> : false }
            </div>
        );
    },

    renderField(id, schema, value, vtype=null) {
        function isValidUrl(value) {
            try {
                var url = new URL(value);
            } catch (error) {
                return false;
            }

            return url.protocol === "http:" || url.protocol === "https:";
        }

        function isValidMail(value) {
            var pattern = /^[a-z0-9\.\-]+@[a-z0-9\.\-]+\.[a-z]{2,4}$/
            return pattern.test(value)
        }

        function renderScalar(schema, value) {
            const type = schema.get('type');
            if (type === 'string' && schema.get('format') === 'date') {
                value = moment(value).format("LL");
            } else if (type === 'string' && schema.get('format') === 'date-time') {
                value = moment(value).format("LLLL");
            } else if (type === 'string' && schema.get('format') === 'date-time-range') {
                value = moment(value).format("LLLL");
            } else if (type === 'boolean') {
                const markClass = "glyphicon glyphicon-" + (value ? "ok":"remove");
                return (
                    <label>
                        <span className="metadata-boolean">{value ? "True":"False"}</span>
                        <span className={markClass} aria-hidden="true"/>
                    </label>
                );
            } else if (vtype) {
                switch (vtype) {
                    case 'DOI':
                        return <Link to={"https://dx.doi.org/" + value} target="_blank">{value}</Link>
                    case 'Handle':
                        return <Link to={"https://hdl.handle.net/" + value} target="_blank">{value}</Link>
                }
            }

            if (isValidUrl(value)) {
                return <Link to={value} target="_blank">{value}</Link>
            } else if (isValidMail(value)) {
                return <Link to={"mailto:" + value} target="_blank">{value}</Link>
            }

            return value;
        }

        if (value === undefined || value === null) {
            return false;
        }

        const type = schema.get('type');
        const title = schema.get('title');
        let inner = null;

        if (id == 'language') {
            const languages = serverCache.getVocabulary('languages');
            if (languages) {
                value = (inner = languages.items.find(l => l.id == value)) ? inner.name : value;
            }
            // maintain root schema v0 compatibility
            inner = <span>{ renderScalar(schema, value) }</span>;
        } else if (type === 'array') {
            inner = (
                <ul className="list-unstyled">
                    { value.map((v,i) => this.renderField(`#${i}`, schema.get('items'), v)) }
                </ul>
            );
        } else if (type === 'object') {
            // determine if object parent has '_type' element that is a string
            const mainid = schema.get('properties').keys().next().value;
            const maintype = schema.get('properties').has(mainid + "_type") ? schema.get('properties').get(mainid + "_type") : null;
            const vtype = (maintype && maintype.get('type') == 'string') ? value.get(mainid + "_type") : null;

            inner = (
                <ul className="list-unstyled">
                    { schema.get('properties').entrySeq().map(([pid, pschema]) => this.renderField(pid, pschema, value.get(pid), pid == mainid ? vtype : null)) }
                </ul>
            );
        } else {
            inner = <span>{renderScalar(schema, value)}</span>
        }

        return (
            <li key={id} className="row">
                { !title ? false :
                    <div className="col-sm-4">
                        <label>{title}</label>
                    </div>
                }
                <div className={
                    (title ? "col-sm-8" : "col-sm-12") + " " + (type === 'object' ? "metadata-object" : "metadata")}>
                     {inner} </div>
            </li>
        );
    },


    renderFieldBlock(schemaID, schema, excludeFields=[]) {
        if (!schema) {
            return <Wait key={schemaID}/>;
        }

        const [majors, minors] = getSchemaOrderedMajorAndMinorFields(schema);
        const metadata_block = this.props.record.get('metadata');
        const metadata = !schemaID ? metadata_block : metadata_block.getIn(['community_specific', schemaID]);

        function renderBigField(excludeFields, [pid, pschema], i) {
            if (excludeFields.includes(pid)) {
                return false;
            }
            const f = this.renderField(pid, pschema, metadata.get(pid));
            if (!f) {
                return false;
            }

            return <div className="metadata-field" key={pid}> {f} </div>;
        }
        const majorFields = majors.entrySeq().map(renderBigField.bind(this, excludeFields));
        const minorFields = minors.entrySeq().map(renderBigField.bind(this, excludeFields));

        return (
            <div key={schemaID||"_"} className={"well " + (schemaID ? "block" : "")}>
                <div className="row">
                    <h3 className="col-sm-9">
                        { schemaID ? schema.get('title') : 'Basic metadata' }
                    </h3>
                    { !schemaID ? false :
                        <span style={{float: 'right'}}>
                            <a className="btn btn-xs btn-default" onClick={() => copyToClipboard(schemaID)}
                               title="Copy community block schema identifier used for this record">
                                <i className="fa fa-clipboard"/>
                            </a>
                        </span>
                    }
                </div>
                <div className="row">
                    <ul className="col-sm-12 list-unstyled">
                        { majorFields }
                    </ul>
                </div>
                <div className="row">
                    <ul className="col-sm-12 list-unstyled">
                        { minorFields }
                    </ul>
                </div>
            </div>
        );
    },

    render() {
        const rootSchema = this.props.rootSchema;
        const blockSchemas = this.props.blockSchemas;
        const record = this.props.record;

        if (!record || !rootSchema) {
            return <Wait/>;
        }

        const recordID = record.get('id');
        const files = record.get('files') || record.getIn(['metadata', '_files']);
        const isLatestVersion = !record.has('versions') || recordID == record.getIn(['versions', 0, 'id']);
        function onNewVersion (e) {
            e.preventDefault();
            serverCache.createRecordVersion(record, newRecordID => browser.gotoEditRecord(newRecordID));
        }
        const state = record.get('metadata').get('publication_state');
        return (
            <div className="container-fluid">
                <div className="large-record bottom-line">
                    <div className="row metadata-main">
                        <div className="col-lg-12">
                            {this.renderFixedFields(record, this.props.community)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            { this.renderFieldBlock(null, rootSchema, this.fixedFields) }

                            { !blockSchemas ? false :
                                blockSchemas.map(([id, blockSchema]) =>
                                    this.renderFieldBlock(id, (blockSchema||Map()).get('json_schema'), [])) }
                        </div>
                        <div className="col-lg-12">
                            { this.renderFileList(files, true) }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 bottom-buttons">
                            { canEditRecord(record) ?
                                <Link to={`/records/${recordID}/edit`} className="btn btn-warning" style={{margin: '0 0.5em'}}><i className="fa fa-pencil"/>&nbsp;
                                    { state == 'draft' ? 'Edit draft metadata' : 'Edit metadata' }</Link>
                                : false
                            }
                            { isRecordOwner(record) && isLatestVersion ?
                                <a href='#' onClick={onNewVersion} className="btn btn-warning"><i className="fa fa-plus"/>&nbsp;
                                    Create New Version</a>
                                : false
                            }
                            <Link to={`/records/${recordID}/abuse`} className="btn btn-default abuse"><i className="glyphicon glyphicon-exclamation-sign"/> Report Abuse</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});


/**
 * Determine if user can edit a record
 * @return: null if undetermined (awaiting data) or bool otherwise
 */
export function canEditRecord(record) {
    const isOwner = isRecordOwner(record);
    const isCommunityAdministrator = isCommunityAdmin(record.getIn(['metadata', 'community']));
    if (isOwner === null || isCommunityAdministrator === null) {
        return null;
    }
    return isOwner || isCommunityAdministrator;
}

/**
 * Determine if user is owner of a record
 * @return: null if undetermined (awaiting data) or bool otherwise
 */
function isRecordOwner(record) {
    const user = serverCache.getUser();
    if (!user) {
        return null;
    }
    const userId = user.get('id');
    return userId && record.getIn(['metadata', 'owners']).indexOf(userId) >= 0;
}

/**
 * Determine if user is community administrator for community
 * @return: null if undetermined (awaiting data) or bool otherwise
 */
export function isCommunityAdmin(communityId) {
    const user = serverCache.getUser();
    if (!user) {
        return null;
    }
    const community = serverCache.getCommunity(communityId);
    if (!community) {
        return null;
    }
    const communityAdminRoleId = community.getIn(['roles', 'admin', 'id']);
    return communityAdminRoleId && user.get('roles', []).find(r => r.get('id') === communityAdminRoleId);
}



// WEBPACK FOOTER //
// ./src/components/record.jsx